
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import ReservationForm from '../../components/feature/ReservationForm';
import { updateSEO, addStructuredData } from '../../utils/seo';

const Habitaciones = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Update SEO
    updateSEO({
      title: 'Habitaciones Privadas - Castilletes Parque Tayrona | Alojamiento con Comodidad',
      description: 'Habitaciones privadas en Castilletes con aire acondicionado, baño privado y desayuno incluido. Desde 2 hasta 8 personas. Reserva tu habitación en el Parque Tayrona.',
      keywords: 'habitaciones Tayrona, alojamiento privado, habitaciones aire acondicionado, Castilletes habitaciones, Parque Tayrona hospedaje',
      canonical: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/habitaciones`
    });

    // Add structured data
    addStructuredData({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Habitaciones Privadas Castilletes",
      "description": "Habitaciones privadas con aire acondicionado, baño privado y desayuno incluido en el Parque Nacional Tayrona",
      "category": "Alojamiento",
      "brand": {
        "@type": "Brand",
        "name": "Castilletes Parque Tayrona"
      },
      "offers": {
        "@type": "AggregateOffer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "COP"
      },
      "amenityFeature": [
        {
          "@type": "LocationFeatureSpecification",
          "name": "Aire acondicionado",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Baño privado",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Desayuno incluido",
          "value": true
        }
      ]
    });
  }, []);

  const [selectedRoom, setSelectedRoom] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<{ [key: string]: number }>({});

  const habitaciones = [
    {
      id: 'jaguar',
      nombre: 'Jaguar 2 pax',
      capacidad: 2,
      descripcion: 'Habitación con baño privado y ducha. Cama doble, Aire acondicionado. Incluido desayuno y Wifi.',
      caracteristicas: [
        'Baño privado con ducha',
        'Cama doble',
        'Aire acondicionado',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/89d134ec920f712d3af538f8b8068fcd.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/75b30dea47f8b9f48ece29a3eed0a38b.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/6f628259820b08b55644398b10672175.png'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'zaino',
      nombre: 'ZAINO 2 pax',
      capacidad: 2,
      descripcion: 'Hermosa habitación privada. Ventilador. Baño compartido. Desayuno incluido. Servicio Wifi. Acceso a Piscina.',
      caracteristicas: [
        'Habitación privada',
        'Ventilador',
        'Baño compartido',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/b5d174a064fe8165f9ca994ed1b51cb9.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/b5d174a064fe8165f9ca994ed1b51cb9.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/0f5e34887780e5fa423f39d3a02d10b9.jpeg'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'titi',
      nombre: 'TITI máx. 3 pax',
      capacidad: 3,
      descripcion: 'Habitación privada con baño compartido. WIFI GRATIS. Ventilador. Servicio de energía eléctrica de 6:00 pm a 8:00 am.',
      caracteristicas: [
        'Habitación privada',
        'Baño compartido',
        'Ventilador',
        'Capacidad hasta 3 personas',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/78fbd5bce501b63f0e990e5a5f86af0f.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/a928579e4651af7dc438577de7a89108.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/d179466f5c886113905fb46ed1b1a598.jpeg'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'iguana',
      nombre: 'IGUANA 3 PAX',
      capacidad: 3,
      descripcion: 'Habitación privada con baño compartido. Aire acondicionado. Desayuno incluido. WIFI GRATIS.',
      caracteristicas: [
        'Habitación privada',
        'Baño compartido',
        'Aire acondicionado',
        'Capacidad hasta 3 personas',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/78fbd5bce501b63f0e990e5a5f86af0f.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/d179466f5c886113905fb46ed1b1a598.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/d179466f5c886113905fb46ed1b1a598.jpeg'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'caiman',
      nombre: 'CAIMAN Max 6 pax',
      capacidad: 6,
      descripcion: 'Habitación con baño privado, Aire acondicionado. Desayuno Incluido. Wifi GRATIS.',
      caracteristicas: [
        'Baño privado',
        'Aire acondicionado',
        'Capacidad hasta 6 personas',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/df113dfdd4d8f3c6a8eb59fd3af81552.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/663dc83c0ae7dc4419de612841dc2d1a.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/ef8efdefd5af9da8a46fdf85946705cc.jpeg'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'guacamaya',
      nombre: 'Guacamaya 2 pax',
      capacidad: 2,
      descripcion: 'Habitación con baño privado. Desayuno incluido. Aire acondicionado',
      caracteristicas: [
        'Baño privado',
        'Aire acondicionado',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/cd35f6e9f2d504c744088aaad618795f.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/706b01e5355d89aa09c3ebe209dcf2ec.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/cd35f6e9f2d504c744088aaad618795f.png'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'cangrejo',
      nombre: 'CANGREJO 4 pax',
      capacidad: 4,
      descripcion: 'habitacion privada con baño compartido. Aire acondicionado. Desayuno incluido. WIFI GRATIS.',
      caracteristicas: [
        'Habitación privada',
        'Baño compartido',
        'Aire acondicionado',
        'Capacidad hasta 4 personas',
        'Desayuno incluido',
        'WiFi gratuito'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/d8b2b04dc9722c1e7380031ac7314640.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/0d8a4322566f7dcdaab4d03e538574d4.jpeg',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/b5d174a064fe8165f9ca994ed1b51cb9.png'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'tortuga',
      nombre: 'TORTUGA Max 6 PAX',
      capacidad: 6,
      descripcion: '1 Cama Doble | 4 Cama sencilla | WIFI GRATIS en áreas comunes. Desayuno Incluido | Baño privado | abanico | Acceso a piscina, restaurante. Máximo 6 PAX.',
      caracteristicas: [
        '1 Cama doble',
        '4 Camas sencillas',
        'Baño privado',
        'Abanico',
        'Desayuno incluido',
        'WiFi gratuito en áreas comunes',
        'Acceso a piscina y restaurante'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/e560b271b66c66816cb035a5efc08ecd.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/462192aa33a514849d3788e7032fb845.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/4163f285801b04d96e666c1a6a8dac3d.png'
      ],
      disponibilidad: 'Sólo queda 1'
    },
    {
      id: 'delfin',
      nombre: 'DELFIN Max 8 PAX',
      capacidad: 8,
      descripcion: '2 Camas Dobles | 4 Camas sencillas | WIFI GRATIS. Desayuno Incluido | Baño privado | Aire acondicionado | Acceso a piscina, restaurante. Máximo 8 PAX.',
      caracteristicas: [
        '2 Camas dobles',
        '4 Camas sencillas',
        'Baño privado',
        'Aire acondicionado',
        'Desayuno incluido',
        'WiFi gratuito',
        'Acceso a piscina y restaurante'
      ],
      imagenes: [
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/462192aa33a514849d3788e7032fb845.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/e560b271b66c66816cb035a5efc08ecd.png',
        'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/e560b271b66c66816cb035a5efc08ecd.png'
      ],
      disponibilidad: 'Sólo queda 1'
    }
  ];

  const nextImage = (habitacionId: string, totalImages: number) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [habitacionId]: ((prev[habitacionId] || 0) + 1) % totalImages
    }));
  };

  const prevImage = (habitacionId: string, totalImages: number) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [habitacionId]: ((prev[habitacionId] || 0) - 1 + totalImages) % totalImages
    }));
  };

  const goToImage = (habitacionId: string, index: number) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [habitacionId]: index
    }));
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 bg-cover bg-center" style={{
        backgroundImage: `url('https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/4798bce62d63c076d8c84a0ad54d23d2.jpeg')`
      }}>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center">
          <div className="text-white max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Habitaciones Privadas</h1>
            <p className="text-xl mb-6">Comodidad y privacidad en el corazón del Tayrona</p>
          </div>
        </div>
      </section>

      {/* Información General - Movida hacia abajo y sin imagen */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Información General</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="flex flex-col items-center space-y-3">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-white text-lg"></i>
                </div>
                <div className="text-center">
                  <div className="font-semibold text-gray-900">Check-in</div>
                  <div className="text-gray-600">2:00 PM</div>
                </div>
              </div>
              <div className="flex flex-col items-center space-y-3">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-white text-lg"></i>
                </div>
                <div className="text-center">
                  <div className="font-semibold text-gray-900">Check-out</div>
                  <div className="text-gray-600">11:00 AM</div>
                </div>
              </div>
              <div className="flex flex-col items-center space-y-3">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-restaurant-line text-white text-lg"></i>
                </div>
                <div className="text-center">
                  <div className="font-semibold text-gray-900">Desayuno</div>
                  <div className="text-gray-600">7:00 AM - 09:00 AM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lista de Habitaciones */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Opciones de Alojamiento
          </h2>
          
          <div className="grid gap-8">
            {habitaciones.map((habitacion) => (
              <div key={habitacion.id} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                <div className="md:flex">
                  <div className="md:w-1/3 relative">
                    {/* Carrusel de imágenes */}
                    <div className="relative h-64 md:h-full overflow-hidden">
                      <img 
                        src={habitacion.imagenes[currentImageIndex[habitacion.id] || 0]}
                        alt={`${habitacion.nombre} - Imagen ${(currentImageIndex[habitacion.id] || 0) + 1}`}
                        className="w-full h-full object-cover object-top"
                      />
                      
                      {/* Botones de navegación */}
                      <button
                        onClick={() => prevImage(habitacion.id, habitacion.imagenes.length)}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
                      >
                        <i className="ri-arrow-left-s-line"></i>
                      </button>
                      <button
                        onClick={() => nextImage(habitacion.id, habitacion.imagenes.length)}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                      </button>
                      
                      {/* Indicadores */}
                      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                        {habitacion.imagenes.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => goToImage(habitacion.id, index)}
                            className={`w-2 h-2 rounded-full transition-colors ${
                              (currentImageIndex[habitacion.id] || 0) === index 
                                ? 'bg-white' 
                                : 'bg-white/50'
                            }`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="md:w-2/3 p-6">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">
                          {habitacion.nombre}
                        </h3>
                        <div className="flex items-center space-x-4 text-sm text-gray-600 mb-3">
                          <div className="flex items-center space-x-1">
                            <i className="ri-user-line"></i>
                            <span>Hasta {habitacion.capacidad} personas</span>
                          </div>
                          {habitacion.disponibilidad && (
                            <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
                              {habitacion.disponibilidad}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-gray-700 mb-4">
                      {habitacion.descripcion}
                    </p>
                    
                    <div className="mb-6">
                      <h4 className="font-semibold text-gray-900 mb-2">Características incluidas:</h4>
                      <div className="grid grid-cols-2 gap-2">
                        {habitacion.caracteristicas.map((caracteristica, index) => (
                          <div key={index} className="flex items-center space-x-2">
                            <i className="ri-check-line text-teal-600"></i>
                            <span className="text-sm text-gray-700">{caracteristica}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div className="flex justify-between items-center">
                      <button
                        onClick={() => setSelectedRoom(selectedRoom === habitacion.id ? null : habitacion.id)}
                        className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {selectedRoom === habitacion.id ? 'Ocultar detalles' : 'Ver más detalles'}
                      </button>
                    </div>
                    
                    {selectedRoom === habitacion.id && (
                      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                        <h5 className="font-semibold text-gray-900 mb-3">Información adicional:</h5>
                        <div className="space-y-2 text-sm text-gray-700">
                          <p>• Todas las habitaciones incluyen acceso a las áreas comunes del hotel</p>
                          <p>• WiFi gratuito disponible en áreas comunes</p>
                          <p>• Acceso a piscina y restaurante</p>
                          <p>• Ubicación privilegiada dentro del Parque Nacional Tayrona</p>
                          <p>• Prohibido el ingreso de mascotas (Política de Parques Nacionales)</p>
                          <p>• Los menores deben ir acompañados de sus padres</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Servicios Incluidos */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Servicios Incluidos
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-restaurant-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Desayuno Incluido</h3>
              <p className="text-gray-600">
                Desayuno continental servido de 7:00 AM a 9:00 AM
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wifi-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">WiFi Gratuito</h3>
              <p className="text-gray-600">
                Conexión a internet disponible en áreas comunes
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-swimming-pool-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Acceso a Piscina</h3>
              <p className="text-gray-600">
                Disfruta de nuestra piscina con vista al mar
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Políticas Importantes */}
      <div className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Políticas Importantes
          </h2>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <div className="flex items-start space-x-3">
              <i className="ri-information-line text-yellow-600 text-xl mt-1"></i>
              <div>
                <h3 className="font-semibold text-yellow-800 mb-3">Información importante:</h3>
                <ul className="space-y-2 text-yellow-700">
                  <li>• Prohibido el ingreso de mascotas (Política de Parques Nacionales de Colombia)</li>
                  <li>• Los menores deben ir acompañados de sus padres</li>
                  <li>• Debe pagar el ingreso al Parque Tayrona por separado</li>
                  <li>• Parqueadero disponible con costo adicional según tarifas del parque</li>
                  <li>• Check-in: 2:00 PM | Check-out: 11:00 AM</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Formulario de Reserva */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <ReservationForm />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Habitaciones;
